import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _desktop, _mobile;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { EEstimationTargets } from '../../types';
import { widgetContext } from '../../context/widgetContext';
import { FlatDesktop } from './components/FlatDesktop';
import { JKDesktop } from './components/JKDesktop';
import { FlatMobile } from './components/FlatMobile';
import { JKMobile } from './components/JKMobile';
import { jsx as _jsx } from "react/jsx-runtime";
var layoutsMap = {
  desktop: (_desktop = {}, _defineProperty(_desktop, EEstimationTargets.flat, FlatDesktop), _defineProperty(_desktop, EEstimationTargets.newbuilding, JKDesktop), _desktop),
  mobile: (_mobile = {}, _defineProperty(_mobile, EEstimationTargets.flat, FlatMobile), _defineProperty(_mobile, EEstimationTargets.newbuilding, JKMobile), _mobile)
};
export var Layout = function Layout(props) {
  var _React$useContext = React.useContext(widgetContext),
      isDesktop = _React$useContext.isDesktop;

  var estimationTarget = props.estimationTargetProps.value;
  var Component = layoutsMap[isDesktop ? 'desktop' : 'mobile'][estimationTarget];
  return /*#__PURE__*/_jsx(Component, _objectSpread({}, props));
};
Layout.displayName = 'Layout';